import { useEffect } from 'react';
import { useConfigCatClient } from 'configcat-react';
import { ConfigCatEnvProviderProps } from './config-cat-env-provider.types';

export const ConfigCatEnvProvider = ({ children }: ConfigCatEnvProviderProps) => {
	const configCatClient = useConfigCatClient();

	useEffect(() => {
		const forceRefreshAsync = async () => {
			await configCatClient.forceRefreshAsync();
		};
		forceRefreshAsync();
	}, [configCatClient]);

	return <>{children}</>;
};

export default ConfigCatEnvProvider;
